
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/yaml-to-json",
      function () {
        return require("private-next-pages/converter/yaml-to-json.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/yaml-to-json"])
      });
    }
  